<template>
  <div class="md:flex">
    <div class="inline-block w-256 mr-16">
      <h3 class="text-overline mb-4">Type</h3>
      <p class="text-body text-left mb-16">Regular sitter</p>
      <h3 class="text-overline mb-4">Start Date</h3>
      <p :class="`text-body text-left ${startDateFlexible ? '' : 'mb-16'}`">{{ formattedStartDate }}</p>
      <p v-if="startDateFlexible" id="start-date-flexible" class="text-body text-left mb-16 italic">Start date is flexible</p>
    </div>
    <div class="inline-block w-256 mb-16">
      <h3 class="text-overline mb-4">Days</h3>
      <p data-test-id="days" class="text-body text-left mb-16">{{ days.join(', ') }}</p>
      <h3 class="text-overline mb-4">Time</h3>
      <p data-test-id="time" class="text-body text-left">{{ timeFrame }}</p>
      <p data-test-id="duration" class="text-body text-left italic">Duration: {{ duration }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { timeframe as buildTimeframe, duration as calculateDuration } from '@/lib/time';

export default {
  name: 'JobPostScheduleRegularReview',
  props: {
    formattedStartDate: {
      type: String,
      required: true,
    },
    startDateFlexible: {
      type: Boolean,
      required: true,
    },
    startTime: {
      type: Date as PropType<Date>,
      required: true,
    },
    endTime: {
      type: Date as PropType<Date>,
      required: true,
    },
    days: {
      type: Array as () => string[],
      required: true,
    },
  },
  computed: {
    duration(): string {
      if (this.startTime && this.endTime) {
        return calculateDuration(this.startTime, this.endTime);
      }

      return '';
    },
    timeFrame(): string {
      if (this.startTime && this.endTime) {
        return buildTimeframe(this.startTime, this.endTime);
      }

      return '';
    },
  },
};
</script>
